import { Box, IconButton, Typography } from '@mui/material'
import { color } from 'config/color'
import AddIcon from '@mui/icons-material/Add'
import { useMobileBreakpoints } from 'utils'
import { type Dispatch, type SetStateAction } from 'react'

interface IAddCampaignCard {
  setActiveTab: Dispatch<SetStateAction<number>>
}

export const AddCampaignCard = (props: IAddCampaignCard): JSX.Element => {
  const isMobile = useMobileBreakpoints()

  return (
    <Box
      p={1.5}
      display="flex"
      flexDirection="column"
      bgcolor={color.grey[50]}
      border={`1px solid ${color.secondary.dark[100]}`}
      height={isMobile ? '18vh' : '16vh'}
      justifyContent="space-evenly"
      alignItems="center"
    >
      <Box>
        <Box display="flex" flexDirection="column" gap={1} alignItems="center">
          <IconButton
            sx={{
              display: 'flex',
              bgcolor: color.secondary.dark[100]
            }}
            onClick={() => {
              props.setActiveTab(1)
            }}
          >
            <AddIcon sx={{ color: color.primary[600], fontSize: '32px' }} />
          </IconButton>

          <Typography color={color.grey[700]} fontWeight={400} fontSize={16}>
            Create a new campaign
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
